import React, { useState, useEffect, useCallback } from "react";
import { Col } from "react-bootstrap";
import { profileSelector } from "store/reducers/ProfileReducer";
import { useSelector } from "react-redux";
import FellowLayout from "../../../Fellow";

const MAX_RETRIES = 2;
const RETRY_DELAY = 2000;

const CareerMentorship = () => {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const { profileInfo } = useSelector(profileSelector);
  const profile = profileInfo && profileInfo.data && profileInfo.data.profile;

  const fetchToken = useCallback(async () => {
    if (!profile || !profile.first_name || !profile.last_name || !profile.email) {
      return;
    }

    setLoading(true);
    try {
      const response = await fetch("https://api.wesonline.us/auth/3mtt/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          first_name: profile.first_name,
          last_name: profile.last_name,
          email: profile.email,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Token fetch result:", result);
      const fetchedToken = result && result.access;

      if (fetchedToken) {
        setToken(fetchedToken);
        setRetryCount(0);
      } else {
        throw new Error("Token not found in response");
      }
    } catch (err) {
      console.error("Error fetching token:", err);
      setRetryCount((prev) => prev + 1);
    } finally {
      setLoading(false);
    }
  }, [profile]);

  useEffect(() => {
    if (profile) {
      fetchToken();
    }
  }, [profile, fetchToken]);

  useEffect(() => {
    if (retryCount > 0 && retryCount <= MAX_RETRIES) {
      const timer = setTimeout(() => {
        fetchToken();
      }, RETRY_DELAY);
      return () => clearTimeout(timer);
    }
  }, [retryCount, fetchToken]);

  const iframeUrl = token ? `https://app.wesonline.ai/auth/login?token=${token}` : null;

  if (!profile) {
    return (
      <FellowLayout>
        <Col xl="12">
          <div className="p-5 text-center">Loading profile...</div>
        </Col>
      </FellowLayout>
    );
  }

  return (
    <FellowLayout>
      <Col xl="12">
        {token && iframeUrl ? (
          <iframe src={iframeUrl} width="100%" height="1000px" title="Wes Online" />
        ) : retryCount > MAX_RETRIES && !loading ? (
          <div className="p-5 text-center text-danger">
            Unable to load resources. Please try again later.
          </div>
        ) : (
          <div className="p-5 text-center">Loading resources...</div>
        )}
      </Col>
    </FellowLayout>
  );
};

export default CareerMentorship;
